import { atom } from 'jotai';

import type { ISort } from '@/ui/table/table.types';
import type { ProjectCompaniesSort } from '@/api/v4/projects.api';

export type WizardStep = 'problemDefinition' | 'companySelection';

export const WIZARD_STEPS = {
  COMPANY_SELECTION: 'companySelection',
  PROBLEM_DEFINITION: 'problemDefinition',
} as const;

export const TEXTAREA_MAX_LENGTH = 2000;

export const TABLE_CONTAINER_HEIGHT = '410px';

export const companyFilterSortState = atom<ISort<ProjectCompaniesSort>>({
  direction: 'desc',
  sort: 'status',
});
